<app-invest-select [selectedInvest]="invest" (projectsChanged)="onProjectsListChanged($event)"></app-invest-select>
<table>
    <thead>
        <tr>
            <th class="project-name" rowspan="2" [matTooltip]="'invest.datatables.project.summary' | translate">
                {{ 'invest.datatables.project.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.project.summary' | translate"></app-tooltip> -->
            </th>
            <th class="project-year" rowspan="2" [matTooltip]="'invest.datatables.year.summary' | translate">
                {{ 'invest.datatables.year.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.year.summary' | translate"></app-tooltip> -->
            </th>
            <th rowspan="2" [matTooltip]="'invest.datatables.spending.summary' | translate">
                {{ 'invest.datatables.spending.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.spending.summary' | translate"></app-tooltip> -->
            </th>
            <th rowspan="2" [matTooltip]="'invest.datatables.function.summary' | translate">
                {{ 'invest.datatables.function.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.function.summary' | translate"></app-tooltip> -->
            </th>

            <th colspan="6" class="alone" [matTooltip]="'invest.datatables.funding.summary' | translate">
                {{ 'invest.datatables.funding.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.funding.summary' | translate"></app-tooltip> -->
            </th>

            <th rowspan="2" [matTooltip]="'invest.datatables.extraFund.summary' | translate">
                {{ 'invest.datatables.extraFund.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.extraFund.summary' | translate"></app-tooltip> -->
            </th>
            <th rowspan="2" [matTooltip]="'invest.datatables.extraBalance.summary' | translate">
                {{ 'invest.datatables.extraBalance.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.extraBalance.summary' | translate"></app-tooltip> -->
            </th>
        </tr>

        <tr>
            <th [matTooltip]="'invest.datatables.loaning.summary' | translate">
                {{ 'invest.datatables.loaning.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.loaning.summary' | translate"></app-tooltip> -->
            </th>
            <th [matTooltip]="'invest.datatables.duration.summary' | translate">
                {{ 'invest.datatables.duration.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.duration.summary' | translate"></app-tooltip> -->
            </th>
            <th [matTooltip]="'invest.datatables.rate.summary' | translate">
                {{ 'invest.datatables.rate.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.rate.summary' | translate"></app-tooltip> -->
            </th>
            <th [matTooltip]="'invest.datatables.ordinaryLevy.summary' | translate">
                {{ 'invest.datatables.ordinaryLevy.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.ordinaryLevy.summary' | translate"></app-tooltip> -->
            </th>
            <th [matTooltip]="'invest.datatables.subsidies.summary' | translate">
                {{ 'invest.datatables.subsidies.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.subsidies.summary' | translate"></app-tooltip> -->
            </th>
            <th [matTooltip]="'invest.datatables.estate.summary' | translate">
                {{ 'invest.datatables.estate.shortLabel' | translate }}
                <!-- <app-tooltip [text]="'invest.datatables.estate.summary' | translate"></app-tooltip> -->
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let project of invest.fundingProject.projects; index as pi">
            <tr *ngFor="let year of project.years; index as i">
                <td *ngIf="i === 0" [attr.rowspan]="project.years.length + 1" class="project-name">
                    <mat-form-field class="name">
                        <input matInput appAutofocus type="text" [(ngModel)]="project.name" onclick="this.select()">
                    </mat-form-field>
                    <button type="button" mat-icon-button color="accent" (click)="onRemoveProject(pi)">
                        <mat-icon aria-label="Add">clear</mat-icon>
                    </button>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="year.year" (selectionChange)="onLoaningTypeChanged(year)">
                            <mat-option *ngFor="let oprion of years" [value]="oprion">
                                {{ oprion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button type="button" mat-icon-button color="accent" (click)="onRemoveYear(project, i)">
                        <mat-icon aria-label="Add">clear</mat-icon>
                    </button>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year)" [value]="year.spending"
                        (valueChanged)="onValueChanged($event, year, 'spending')"></app-invest-input>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="year.investmentFunctionCode" (selectionChange)="onLoaningTypeChanged(year)">
                            <mat-option *ngFor="let option of invest.fundingProject.options.investmentFunction" [value]="option.code">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year)" [value]="year.loaningAmount"
                        (valueChanged)="onValueChanged($event, year, 'loaningAmount')"></app-invest-input>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="year.loaningTypeCode"
                            [disabled]="year.loaningAmount === 0 || year.year == null"
                            (selectionChange)="onLoaningTypeChanged(year)">
                            <mat-option *ngFor="let option of rateCurve" [value]="option.code">
                                {{ option.text.shortLabel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <app-invest-input *ngIf="year.loaningAmount !== 0  && year.year != null"
                        [isError]="checkError(year)" [value]="year.rate?.value" [mode]="indiceMode.percent"
                        (valueChanged)="onValueChanged($event, year, 'rate')"></app-invest-input>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year, 'ordinaryLevy')" [value]="year.ordinaryLevy"
                        (valueChanged)="onValueChanged($event, year, 'ordinaryLevy')"></app-invest-input>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year)" [value]="year.subsidies"
                        (valueChanged)="onValueChanged($event, year, 'subsidies')"></app-invest-input>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year)" [value]="year.estate"
                        (valueChanged)="onValueChanged($event, year, 'estate')"></app-invest-input>
                </td>
                <td>
                    <app-invest-input [isError]="checkError(year, 'extraFund')" [value]="year.extraFund"
                        (valueChanged)="onValueChanged($event, year, 'extraFund')"></app-invest-input>
                </td>
                <td [ngClass]="{errorCell: checkError(year)}">{{ year.extraBalance | formatAmount }}</td>
            </tr>
            <tr>
                <td colspan="11" class="alone">
                    <button type="button" mat-icon-button color="accent" (click)="onAddYear(project)">
                        <mat-icon aria-label="Add"
                        [matTooltip]="'invest.projects.addYear.shortLabel' | translate">add</mat-icon>
                    </button>
                </td>
            </tr>
        </ng-container>
        <tr>
            <td colspan="12" class="project-add">
                <button mat-icon-button color="accent" class="add-btn" (click)="onAddProject()">
                    <mat-icon aria-label="Add"
                        [matTooltip]="'invest.projects.addProject.shortLabel' | translate">add</mat-icon>
                </button>
            </td>
        </tr>
    </tbody>
</table>
